import { FC } from 'react'

const AnimatedChartExample: FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 300">
      <style>
        {`
          .bar {
              transition: opacity 0.3s;
              cursor: pointer;
          }
          .bar:hover {
              opacity: 0.8;
          }
          .bar-number {
              transition: font-size 0.3s;
          }
          .bar:hover + .bar-number {
              font-size: 16px;
          }
        `}
      </style>
      
      <g>
        <rect className="bar" x="100" y="130" width="40" height="115" fill="black">
          <animate attributeName="height" dur="0.3s" begin="mouseover" fill="freeze"
                  from="115" to="105" repeatCount="1"/>
          <animate attributeName="y" dur="0.3s" begin="mouseover" fill="freeze"
                  from="130" to="140" repeatCount="1"/>
          <animate attributeName="height" dur="0.3s" begin="mouseout" fill="freeze"
                  from="105" to="115" repeatCount="1"/>
          <animate attributeName="y" dur="0.3s" begin="mouseout" fill="freeze"
                  from="140" to="130" repeatCount="1"/>
        </rect>
        <text className="bar-number" x="120" y="190" textAnchor="middle" fill="white" fontSize="14">120</text>
      </g>

      <g>
        <rect className="bar" x="180" y="100" width="40" height="145" fill="#6495ED">
          <animate attributeName="height" dur="0.3s" begin="mouseover" fill="freeze"
                  from="145" to="135" repeatCount="1"/>
          <animate attributeName="y" dur="0.3s" begin="mouseover" fill="freeze"
                  from="100" to="110" repeatCount="1"/>
          <animate attributeName="height" dur="0.3s" begin="mouseout" fill="freeze"
                  from="135" to="145" repeatCount="1"/>
          <animate attributeName="y" dur="0.3s" begin="mouseout" fill="freeze"
                  from="110" to="100" repeatCount="1"/>
        </rect>
        <text className="bar-number" x="200" y="175" textAnchor="middle" fill="white" fontSize="14">150</text>
      </g>
      
      <g>
        <rect className="bar" x="260" y="70" width="40" height="175" fill="#FF9999">
          <animate attributeName="height" dur="0.3s" begin="mouseover" fill="freeze"
                  from="175" to="165" repeatCount="1"/>
          <animate attributeName="y" dur="0.3s" begin="mouseover" fill="freeze"
                  from="70" to="80" repeatCount="1"/>
          <animate attributeName="height" dur="0.3s" begin="mouseout" fill="freeze"
                  from="165" to="175" repeatCount="1"/>
          <animate attributeName="y" dur="0.3s" begin="mouseout" fill="freeze"
                  from="80" to="70" repeatCount="1"/>
        </rect>
        <text className="bar-number" x="280" y="160" textAnchor="middle" fill="black" fontSize="14">180</text>
      </g>

      <line x1="60" y1="245" x2="60" y2="50" stroke="black" strokeWidth="2"/>
      <line x1="55" y1="245" x2="65" y2="245" stroke="black" strokeWidth="2"/>
      <text x="50" y="248" textAnchor="end" fontSize="10">0</text>
      
      <line x1="55" y1="205" x2="65" y2="205" stroke="black" strokeWidth="2"/>
      <text x="50" y="208" textAnchor="end" fontSize="10">40</text>
      
      <line x1="55" y1="165" x2="65" y2="165" stroke="black" strokeWidth="2"/>
      <text x="50" y="168" textAnchor="end" fontSize="10">80</text>
      
      <line x1="55" y1="125" x2="65" y2="125" stroke="black" strokeWidth="2"/>
      <text x="50" y="128" textAnchor="end" fontSize="10">120</text>
      
      <line x1="55" y1="85" x2="65" y2="85" stroke="black" strokeWidth="2"/>
      <text x="50" y="88" textAnchor="end" fontSize="10">160</text>
      
      <line x1="55" y1="50" x2="65" y2="50" stroke="black" strokeWidth="2"/>
      <text x="50" y="53" textAnchor="end" fontSize="10">200</text>
      
      <line x1="60" y1="245" x2="340" y2="245" stroke="black" strokeWidth="2"/>
      <line x1="120" y1="240" x2="120" y2="250" stroke="black" strokeWidth="2"/>
      <text x="120" y="260" textAnchor="middle" fontSize="10">1</text>
      
      <line x1="200" y1="240" x2="200" y2="250" stroke="black" strokeWidth="2"/>
      <text x="200" y="260" textAnchor="middle" fontSize="10">2</text>

      <line x1="280" y1="240" x2="280" y2="250" stroke="black" strokeWidth="2"/>
      <text x="280" y="260" textAnchor="middle" fontSize="10">3</text>
    </svg>
  )
}

export default AnimatedChartExample 